import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Contact me", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sf-std-block" }, " I always welcome the feedback of teachers. Please let me know if you have any problems accessing the content or ideas for improving the activities or website. ", -1)
const _hoisted_5 = { class: "tw-flex tw-justify-center" }
const _hoisted_6 = { class: "tw-w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, " Name* ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, " Email* ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, " Message* ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "sf-btn-primary"
  }, "Send message")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.status == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Your message has been sent. Thank you very much. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("form", {
                onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
              }, [
                _createVNode(_component_FormInput, {
                  modelValue: _ctx.formData.fields.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.fields.name) = $event))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.fields.name.value) = $event)),
                      class: "sf-form-control tw-w-full"
                    }, null, 512), [
                      [_vModelText, _ctx.formData.fields.name.value]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_FormInput, {
                  modelValue: _ctx.formData.fields.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.fields.email) = $event))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.fields.email.value) = $event)),
                      class: "sf-form-control tw-w-full"
                    }, null, 512), [
                      [_vModelText, _ctx.formData.fields.email.value]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_FormInput, {
                  modelValue: _ctx.formData.fields.message,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.fields.message) = $event))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.fields.message.value) = $event)),
                      class: "sf-form-control tw-w-full tw-h-24"
                    }, null, 512), [
                      [_vModelText, _ctx.formData.fields.message.value]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_10
              ], 32)
            ])
          ])
        ]))
  ]))
}